module.exports = __webpack_public_path__ + "static/media/loading.194ef600.gif";